export default {
  animationEnabled: false,
  gestureEnabled: false,
};
